import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import assert from '../utils/assert';
import { isImageTypeSupported, getDefaultImageType } from '../category-api/image-type';
import { getImageData } from '../category-api/parsed-image-api';
import parseToImage from './parse-to-image';
import parseToImageBitmap from './parse-to-image-bitmap';
import parseToNodeImage from './parse-to-node-image';
export default function parseImage(_x, _x2, _x3) {
  return _parseImage.apply(this, arguments);
}
function _parseImage() {
  _parseImage = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(arrayBuffer, options, context) {
    var imageOptions, imageType, _ref, url, loadType, image;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = options || {};
            imageOptions = options.image || {};
            imageType = imageOptions.type || 'auto';
            _ref = context || {}, url = _ref.url;
            loadType = getLoadableImageType(imageType);
            _context.t0 = loadType;
            _context.next = _context.t0 === 'imagebitmap' ? 8 : _context.t0 === 'image' ? 12 : _context.t0 === 'data' ? 16 : 20;
            break;
          case 8:
            _context.next = 10;
            return parseToImageBitmap(arrayBuffer, options, url);
          case 10:
            image = _context.sent;
            return _context.abrupt("break", 21);
          case 12:
            _context.next = 14;
            return parseToImage(arrayBuffer, options, url);
          case 14:
            image = _context.sent;
            return _context.abrupt("break", 21);
          case 16:
            _context.next = 18;
            return parseToNodeImage(arrayBuffer, options);
          case 18:
            image = _context.sent;
            return _context.abrupt("break", 21);
          case 20:
            assert(false);
          case 21:
            if (imageType === 'data') {
              image = getImageData(image);
            }
            return _context.abrupt("return", image);
          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseImage.apply(this, arguments);
}
function getLoadableImageType(type) {
  switch (type) {
    case 'auto':
    case 'data':
      return getDefaultImageType();
    default:
      isImageTypeSupported(type);
      return type;
  }
}